import { logOutFunction } from '../../components/Layout';
import api from './apis';

const apis = {
    auth: async (url, reqData) => await api.post(url, reqData).then((res) => res),
    getDatas: async (url, queryParams, type) =>
        await api
            .get(url, queryParams, type)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    logOutFunction();
                    localStorage.clear();
                }
                return Promise.reject(error);
            }),
    createData: async (url, queryParams, config = {}) =>
        await api
            .post(url, queryParams, { ...config })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    logOutFunction();
                }
                return Promise.reject(error);
            }),
    updateData: async (url, queryParams) =>
        await api
            .put(url, queryParams)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    logOutFunction();
                }
                return Promise.reject(error);
            }),
    patchData: async (url, data, config = {}) =>
        await api
            .patch(url, data, { ...config })
            .then((res) => res)
            .catch((error) => {
                if (error.response?.status === 401) {
                    logOutFunction();
                }
                return Promise.reject(error);
            }),

    deleteData: async (url, queryParams) =>
        await api
            .delete(url, queryParams)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    logOutFunction();
                }
                return Promise.reject(error);
            }),
};
export default apis;
